import { RootStateOrAny } from "react-redux";
import { AnyAction } from "@reduxjs/toolkit";
import { SYSTEM_INITIALIZED } from "@/Redux/System/SystemConstants";

export type SystemState = typeof INITIAL_STATE;

const INITIAL_STATE = {
    initialized: false,
};

export default function SystemReducer(
    state = INITIAL_STATE,
    action: AnyAction,
) {
    switch (action.type) {
        case SYSTEM_INITIALIZED:
            return {
                ...state,
                initialized: true,
            };
        default:
            return state;
    }
}

export const getState = (state: RootStateOrAny) => {
    if (typeof state.system === "object") {
        return state.system;
    }
    return state;
};
